import { useCallback } from "react";

import html2canvas from "html2canvas";

import shutterSoundAsset from "@app/assets/map/shutter-sound.wav";
import { useMap } from "@app/component/map/FeaturedMap";
import { downloadFile } from "@app/util/file";

import styles from "./useMapSnapshotTaker.module.scss";

const shutterSound = new Audio(shutterSoundAsset);
shutterSound.volume = 0.5;

const useMapSnapshotTaker = () => {
  const { map } = useMap();
  return useCallback(async () => {
    // apply some visual and audio effects when taking a screenshot
    // make "flash" and play camera shutter sound

    const flashDiv = document.createElement("div");
    flashDiv.addEventListener(
      "animationstart",
      () => shutterSound.play() // only play sound when animation starts, to sync them
    );
    document.body.append(flashDiv);

    // start animation when sound is loaded
    if (shutterSound.readyState === HTMLMediaElement.HAVE_ENOUGH_DATA) {
      flashDiv.className = styles.container;
    } else {
      shutterSound.oncanplaythrough = function () {
        flashDiv.className = styles.container;
      };
    }

    try {
      const mapElement = map.getDiv();
      const canvas = await html2canvas(mapElement, { logging: false, useCORS: true });
      await new Promise<void>((resolve) => {
        canvas.toBlob((blob) => {
          if (blob) {
            downloadFile("mapmycustomers-map.png", blob);
          }
          resolve();
        });
      });
    } finally {
      flashDiv.remove();
    }
  }, [map]);
};

export default useMapSnapshotTaker;
